exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FillStatus_filled_2ETG {\n  color: #007300;\n}\n\n.FillStatus_partiallyFilled_1unS {\n  color: #f6a000;\n}\n\n.FillStatus_notFilled_3UlE {\n  color: #db443f;\n}\n", ""]);

// exports
exports.locals = {
	"filled": "FillStatus_filled_2ETG",
	"partiallyFilled": "FillStatus_partiallyFilled_1unS",
	"notFilled": "FillStatus_notFilled_3UlE"
};